module.exports = __webpack_public_path__ + "img/starbucks2.ccbd29e8.png";